import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import LiveLayout from "./LiveLayout";
import D13Footer from "../preview/D13Footer";
import { Star } from "./Star";
import "./Editorial.css";

/* ============================================================
   SpokePage — shared shell for the dedicated (deep) pages.
   Persistent routed header (LiveLayout) + an eyebrow-breadcrumb
   back to the audience overview + a page title, then the content,
   then a "keep exploring" hand-off to a sibling page + footer.
   ============================================================ */

export default function SpokePage({ audience, eyebrow, title, intro, next, children }) {
  const overviewTo = audience === "employer" ? "/employers" : "/candidates";
  const overviewLabel = audience === "employer" ? "For employers" : "For job seekers";

  return (
    <LiveLayout audience={audience}>
      <header className="ed-band ed-band--cream spoke-head">
        <div className="ed-container">
          <Link to={overviewTo} className="spoke-crumb">
            <ArrowLeft size={14} strokeWidth={2.4} /> {overviewLabel} · Overview
          </Link>
          {eyebrow && (
            <span className="ed-eyebrow spoke-head__eyebrow"><Star className="ed-eyebrow__star" /> {eyebrow}</span>
          )}
          <h1 className="spoke-title">{title}</h1>
          {intro && <p className="ed-lede spoke-intro">{intro}</p>}
        </div>
      </header>

      {children}

      {next && (
        <section className="ed-band ed-band--ink ed-pad">
          <div className="ed-container spoke-next">
            <span className="ed-eyebrow"><Star className="ed-eyebrow__star" /> Keep exploring</span>
            <Link to={next.to} className="spoke-next__link">
              {next.label} <ArrowRight size={22} strokeWidth={2.1} />
            </Link>
          </div>
        </section>
      )}

      <D13Footer />
    </LiveLayout>
  );
}
